import { lucideIcons } from '../app.js';

const COMPETITORS = ['BlindKeep', '1Password', 'Bitwarden', 'Tresorit', 'ProtonDrive', 'Google Drive', 'LastPass'];

// ● = supported  · = not supported  ◐ = partial  — = not applicable
const SECTIONS = [
  {
    title: 'Encryption',
    icon: 'shield-check',
    rows: [
      ['Zero-knowledge E2E encryption',       '●', '●', '●', '●', '●', '·', '●'],
      ['Client-side crypto (WASM)',            '●', '·', '·', '·', '·', '·', '·'],
      ['Server never sees password',           '●', '●', '◐', '—', '—', '·', '·'],
      ['Open crypto primitives (XChaCha20 + X25519)', '●', '·', '●', '·', '●', '—', '·'],
    ]
  },
  {
    title: 'Sharing',
    icon: 'share-2',
    rows: [
      ['Share with non-users (no account needed)', '●', '·', '●', '●', '·', '●', '·'],
      ['Zero-knowledge link sharing',          '●', '·', '·', '·', '·', '·', '·'],
      ['Passphrase-protected drops (BIP39)',    '●', '·', '·', '·', '·', '·', '·'],
      ['Email sharing of encrypted drops',      '●', '·', '·', '·', '·', '·', '·'],
      ['Claim-to-vault (save drop permanently)','●', '·', '·', '·', '·', '·', '·'],
      ['Time-limited shares',                   '●', '·', '●', '●', '●', '●', '·'],
      ['View-capped shares (max views)',        '●', '·', '·', '·', '·', '·', '·'],
      ['IP-restricted shares (CIDR)',           '●', '·', '·', '·', '·', '·', '·'],
      ['Per-access grantor notifications',      '●', '·', '·', '·', '·', '·', '·'],
      ['One-click revocation',                  '●', '●', '●', '●', '●', '●', '·'],
      ['Delegated re-sharing',                  '●', '·', '·', '·', '·', '·', '·'],
    ]
  },
  {
    title: 'Digital Inheritance',
    icon: 'scroll-text',
    rows: [
      ['Digital will (heir designation)',       '●', '·', '●', '·', '·', '●', '●'],
      ['Dead man\'s switch (auto-trigger)',     '●', '·', '·', '·', '·', '·', '·'],
      ['Zero-knowledge inheritance',            '●', '—', '·', '—', '—', '·', '·'],
      ['Heir access without account',           '●', '—', '·', '—', '—', '·', '·'],
      ['Configurable grace period',             '●', '—', '·', '—', '—', '·', '·'],
    ]
  },
  {
    title: 'Anonymous Drops',
    icon: 'upload-cloud',
    rows: [
      ['Encrypted file drops (no account)',     '●', '·', '·', '·', '·', '·', '·'],
      ['Auto-expiring shares (60 min)',         '●', '·', '·', '·', '·', '·', '·'],
    ]
  },
  {
    title: 'Storage',
    icon: 'hard-drive',
    rows: [
      ['Encrypted file storage',                '●', '●', '·', '●', '●', '·', '·'],
      ['Encrypted text/passwords',              '●', '●', '●', '·', '·', '·', '●'],
      ['Drag-and-drop file upload',             '●', '·', '·', '●', '●', '●', '·'],
      ['Presigned S3 uploads (no proxy)',        '●', '·', '·', '·', '·', '·', '·'],
    ]
  },
  {
    title: 'Pricing',
    icon: 'credit-card',
    rows: [
      ['Pay-as-you-go (no subscription)',       '●', '·', '·', '·', '·', '·', '·'],
      ['MB\u00B7hour metering',                 '●', '·', '·', '·', '·', '·', '·'],
      ['Free tier included',                    '●', '·', '●', '·', '·', '●', '●'],
      ['No surprise bills',                     '●', '—', '—', '—', '—', '—', '—'],
      ['Auto data destruction on lapse',        '●', '·', '·', '·', '·', '·', '·'],
      ['Low-balance warning emails',            '●', '·', '·', '·', '·', '·', '·'],
    ]
  },
  {
    title: 'Platforms',
    icon: 'smartphone',
    rows: [
      ['Web app (SPA)',                         '●', '●', '●', '●', '●', '●', '●'],
      ['Native mobile app (iOS + Android)',     '●', '●', '●', '●', '●', '●', '●'],
      ['Screenshot/recording detection',        '●', '·', '·', '·', '·', '·', '·'],
    ]
  },
  {
    title: 'Audit & Compliance',
    icon: 'file-text',
    rows: [
      ['Full audit trail (all actions)',        '●', '●', '●', '●', '·', '●', '●'],
      ['Queryable audit log UI',                '●', '●', '●', '●', '·', '●', '·'],
      ['IP logging per action',                 '●', '●', '●', '●', '·', '●', '·'],
      ['Client security event reporting',       '●', '·', '·', '·', '·', '·', '·'],
      ['EU data residency',                     '●', '·', '·', '●', '●', '·', '·'],
    ]
  },
  {
    title: 'Authentication',
    icon: 'fingerprint',
    rows: [
      ['Passkeys (WebAuthn + PRF)',             '●', '●', '●', '·', '·', '●', '·'],
      ['Magic link (passwordless)',             '●', '·', '·', '·', '·', '·', '·'],
      ['Email-first adaptive login',            '●', '·', '·', '·', '·', '·', '·'],
      ['Account recovery key',                  '●', '●', '·', '·', '·', '·', '·'],
      ['BIP39 mnemonic recovery',               '●', '·', '·', '·', '·', '·', '·'],
      ['HIBP password breach check',            '●', '◐', '·', '·', '·', '·', '·'],
      ['User enumeration prevention',           '●', '●', '·', '·', '·', '·', '·'],
    ]
  },
];

function cellClass(val) {
  if (val === '●') return 'cmp-yes';
  if (val === '·') return 'cmp-no';
  if (val === '◐') return 'cmp-partial';
  return 'cmp-na';
}

function cellLabel(val) {
  if (val === '●') return 'Yes';
  if (val === '·') return 'No';
  if (val === '◐') return 'Partial';
  return 'N/A';
}

export function renderCompare(container) {
  const headerCells = COMPETITORS.map((name, i) =>
    `<th class="${i === 0 ? 'cmp-sticky-col cmp-highlight-col' : ''}">${name}</th>`
  ).join('');

  const sectionHtml = SECTIONS.map(section => {
    const rowsHtml = section.rows.map(row => {
      const feature = row[0];
      const cells = row.slice(1).map((val, i) =>
        `<td class="${cellClass(val)}${i === 0 ? ' cmp-highlight-col' : ''}" title="${cellLabel(val)}">${val}</td>`
      ).join('');
      return `<tr><td class="cmp-feature">${feature}</td>${cells}</tr>`;
    }).join('');

    return `
      <tr class="cmp-section-row">
        <td colspan="${COMPETITORS.length + 1}">
          <i data-lucide="${section.icon}" style="width:16px;height:16px"></i>
          ${section.title}
        </td>
      </tr>
      ${rowsHtml}`;
  }).join('');

  container.innerHTML = `
    <div class="landing-header">
      <a class="landing-logo" href="#/drop" style="text-decoration:none;color:var(--text)">
        <svg viewBox="0 0 32 32" width="36" height="36" style="flex-shrink:0"><defs><linearGradient id="bk-cmp" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-cmp)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-cmp)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-cmp)" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="brand">Blind<span>Keep</span></div>
      </a>
      <a class="landing-signin" href="#/login">Sign in</a>
    </div>
    <div class="compare-body">
      <div class="compare-header">
        <a href="#/drop" class="compare-back"><i data-lucide="arrow-left" style="width:16px;height:16px"></i></a>
        <div>
          <h1 class="compare-title">Feature Comparison</h1>
          <p class="compare-subtitle">How BlindKeep stacks up against the alternatives</p>
        </div>
      </div>

      <div class="cmp-legend">
        <span><span class="cmp-dot cmp-yes">●</span> Supported</span>
        <span><span class="cmp-dot cmp-partial">◐</span> Partial</span>
        <span><span class="cmp-dot cmp-no">·</span> Not supported</span>
        <span><span class="cmp-dot cmp-na">—</span> N/A</span>
      </div>

      <div class="cmp-table-wrap">
        <table class="cmp-table">
          <thead>
            <tr>
              <th class="cmp-feature-header">Feature</th>
              ${headerCells}
            </tr>
          </thead>
          <tbody>
            ${sectionHtml}
          </tbody>
        </table>
      </div>

      <div class="cmp-takeaways">
        <h2>Key Takeaways</h2>
        <ul>
          <li><strong>Only product</strong> combining zero-knowledge encryption, policy-rich sharing with non-users, automated digital inheritance, and usage-based pricing</li>
          <li><strong>Passphrase-protected drops</strong> use BIP39 mnemonics to separate the link from the secret \u2014 an intercepted link is worthless without the 12 words</li>
          <li><strong>Dead man\u2019s switch</strong> is unique to BlindKeep \u2014 no major competitor offers automatic will activation based on inactivity</li>
          <li><strong>MB\u00B7hour pay-as-you-go</strong> eliminates subscriptions entirely</li>
          <li><strong>View-capped and IP-restricted shares</strong> give grant policies no competitor matches</li>
          <li><strong>EU data residency</strong> \u2014 data never leaves the EU, hosted on Scaleway (France)</li>
        </ul>
      </div>

      <div style="text-align:center;margin-top:32px">
        <a href="#/login" class="btn btn-primary" style="width:auto;padding:14px 32px">Get started free &rarr;</a>
        <p style="font-size:12px;color:var(--text-secondary);margin-top:8px">1 GB\u00B7month free, no card needed</p>
      </div>

      <div class="landing-footer" style="margin-top:32px">
        <a href="#/architecture" class="arch-footer-link">End-to-end encrypted</a> &middot;
        <a href="#/architecture" class="arch-footer-link">Zero knowledge</a> &middot;
        <a href="#/privacy" class="arch-footer-link">No tracking</a> &middot;
        <a href="#/compare" class="arch-footer-link">Compare</a> &middot;
        <a href="#/faq" class="arch-footer-link">FAQ</a>
      </div>
      <div class="eu-badge">\uD83C\uDDEA\uD83C\uDDFA Made &amp; operated in the EU</div>
    </div>
  `;
  lucideIcons();
}
